import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="flex justify-center py-3 border-t border-slate-200">
      <div className="flex items-center gap-1">

        {/* Previous */}
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          className={`h-8 w-8 flex items-center justify-center rounded-md text-sm transition
            ${
              currentPage === 1
                ? "text-slate-300 cursor-not-allowed"
                : "text-slate-600 hover:bg-amber-50 hover:text-amber-600"
            }`}
        >
          &lt;
        </button>

        {/* Page Numbers */}
        {(() => {
          const pages = [];
          const range = 1; // Number of pages to show on either side of current page

          for (let i = 1; i <= totalPages; i++) {
            if (
              i === 1 || // First page
              i === totalPages || // Last page
              (i >= currentPage - range && i <= currentPage + range) // Range around current
            ) {
              pages.push(i);
            } else if (
              i === currentPage - range - 1 ||
              i === currentPage + range + 1
            ) {
              pages.push("...");
            }
          }

          // Filter out consecutive dots
          return pages
            .filter((page, index) => page !== "..." || pages[index - 1] !== "...")
            .map((page, index) =>
              page === "..." ? (
                <span key={`dots-${index}`} className="px-2 text-slate-400">
                  ...
                </span>
              ) : (
                <button
                  key={page}
                  onClick={() => goToPage(page)}
                  className={`h-8 min-w-[32px] px-2 rounded-md text-sm font-medium transition
                  ${
                    currentPage === page
                      ? "bg-blue-900 text-white"
                      : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"
                  }`}
                >
                  {page}
                </button>
              ),
            );
        })()}

        {/* Next */}
        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className={`h-8 w-8 flex items-center justify-center rounded-md text-sm transition
            ${
              currentPage === totalPages || totalPages === 0
                ? "text-slate-300 cursor-not-allowed"
                : "text-slate-600 hover:bg-amber-50 hover:text-amber-600"
            }`}
        >
          &gt;
        </button>

      </div>
    </div>
  );
};

export default Pagination;
